import type transform from '../to/groups';

export default (groups: ReturnType<typeof transform>) => {
  if (groups.length != new Set(groups.map(x => x.id)).size)
    throw new Error('(Core::From::V2::Groups) Groups array have two or more groups with the same ID');

  return groups
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::Groups) Group id is undefined');

      return { ...x };
    });
};
